import { TotalCondition } from "../../../serviceOrdering/interfaces/ServiceReport.ts";

type Props = {
  width: string;
  totalCondition: TotalCondition;
};
export const PercentagesTotalCondition = ({ width, totalCondition }: Props) => {
  return (
    <div className="mt-3" style={{ width }}>
      <div className="condition-gauge">
        <div
          style={{ width: totalCondition.new.percentage + `%` }}
          className="condition-gauge__part color-blue"
        >
          {totalCondition.new.percentage}%
        </div>
        <div
          style={{ width: totalCondition.good.percentage + `%` }}
          className="condition-gauge__part color-green"
        >
          {totalCondition.good.percentage}%
        </div>
        <div
          style={{ width: totalCondition.average.percentage + `%` }}
          className="condition-gauge__part color-orange"
        >
          {totalCondition.average.percentage}%
        </div>
        <div
          style={{ width: totalCondition.poor.percentage + `%` }}
          className="condition-gauge__part color-red"
        >
          {totalCondition.poor.percentage}%
        </div>
        <div
          style={{ width: totalCondition.oof.percentage + `%` }}
          className="condition-gauge__part color-gray-dark"
        >
          {totalCondition.oof.percentage}%
        </div>
      </div>
      <ul className="condition-gauge-caption">
        <li className="condition-gauge-caption__new">Neuf</li>
        <li className="condition-gauge-caption__good">Bon état</li>
        <li className="condition-gauge-caption__average">État moyen</li>
        <li className="condition-gauge-caption__bad">Dégradé</li>
        <li className="condition-gauge-caption__hs">HS</li>
      </ul>
    </div>
  );
};
